import { render } from "./S124555.vue?vue&type=template&id=649cc0b0"
const script = {}
script.render = render

export default script